export const blockquoteTheme = {
    root: {
        base: 'text-xl italic font-semibold text-gray-900 dark:text-white',
    },
};
